'use client'

import { useLiveVenuePayloads } from '@/service/venue-health.hook'
import { replayCachedTickers } from '@/service/ws/ticker-channel-cache'
import {
  createMultiStreamHook,
  type MarketDataStreamPayload,
} from '@/service/ws/use-web-socket-with-proto'
import { TickerList } from '@/types/generated/common/types'

const useRawMultiTickerStream = createMultiStreamHook<MarketDataStreamPayload, TickerList>({
  channelKey: 'marketDataStream',
  extractResponse: (message, payloads) => {
    const subscribedKeys = new Set(
      payloads.map((payload) => `${payload.exchange}:${payload.symbol}`)
    )
    const tickers = message.data?.tickers?.tickers.filter((ticker) =>
      subscribedKeys.has(`${ticker.exchange}:${ticker.symbol}`)
    )
    return tickers?.length ? { tickers } : undefined
  },
  listenerChannelKey: 'marketDataStream:tickers',
  replay: replayCachedTickers,
})

export function useMultiTickerStream(options: Parameters<typeof useRawMultiTickerStream>[0]) {
  const connected = options.connected ?? true
  const payloads = useLiveVenuePayloads(options.payloads, connected)
  return useRawMultiTickerStream({
    ...options,
    connected: payloads.length > 0,
    payloads,
  })
}
